module.exports = __webpack_public_path__ + "static/img/used@3x948f35f.png";